import { IWidgetCard } from '@entities/widget-card/model/types';
import { useGetWidgetInfo, useGetWidgetsListQuery } from '@entities/widget-shop/api/hooks';

export const useGetWidgetCardData = ({
    pickedWidgetId,
    fromWidgetPage = false,
}: {
    pickedWidgetId: IWidgetCard['id'] | null;
    fromWidgetPage: boolean;
}) => {
    const shouldLoadWidgetsList = fromWidgetPage;
    const shouldLoadWidgetInfo = !fromWidgetPage && !!pickedWidgetId;

    const { data } = useGetWidgetsListQuery({ enabled: shouldLoadWidgetsList });
    const { data: widgetInfo } = useGetWidgetInfo({
        enabled: shouldLoadWidgetInfo,
        pickedWidgetId,
    });

    const allWidgets = shouldLoadWidgetsList
        ? data?.categories?.map((category) => category?.widgetsList).flat()
        : undefined;
    const pickedWidgetCard = shouldLoadWidgetsList
        ? allWidgets?.find((widget) => widget.id === pickedWidgetId)
        : widgetInfo?.widget;

    const SLIDES =
        pickedWidgetCard?.fullDescriptionData?.attachedImages?.map((image) => ({
            id: image.id,
            image: image.url,
        })) ?? [];

    return {
        widgetCardData: pickedWidgetCard,
        widgetContext: shouldLoadWidgetsList ? data?.context : widgetInfo?.context,
        SLIDES,
    };
};
